<template>
	<div>
		<div class="flex items-center justify-between gap-2 justify-end py-4 w-full">
			<div class="cursor-pointer flex gap-2 w-fit rounded text-[0.8rem]">
				<!-- <a @click="$emit('exportarOutliers')" class="hover:underline">{{ $t("exportarOutliers") }}</a> -->
				<label
					style="cursor: pointer"
					for="newFile"
				>
					{{ $t('arquivoEmEdicao') }} <strong>{{ filename }}</strong>
					<a class="hover:underline"> {{ $t('replaceMeasurement') }}</a>
					<input
						id="newFile"
						type="file"
						style="display: none"
						@change="$emit('change', $event.srcElement.files[0])"
					/>
				</label>
			</div>
			<a
				v-if="filterIds.length"
				class="text-sm"
				@click="$emit('limparFiltros')"
				>Limpar filtros</a
			>
			<Checkbox
				v-model="showInAttention"
				:disabled="!linhasInconsistentes.length"
				label="Exibir apenas linhas com problemas"
			/>
			<InputSearch
				v-model="query"
				class="!w-[30%]"
			/>
		</div>
		<div class="datamapper__grid__container">
			<table
				cellspacing="0"
				class="w-full"
			>
				<thead
					style="background-color: #fafdfb; display: table; width: 100%; table-layout: fixed"
					:style="hasScroll ? 'width: calc( 100% - 0.6em )' : '100%'"
				>
					<th
						v-for="coluna in colunas"
						:key="coluna.nome"
						style="border: solid 0.5px #ccc"
					>
						<div style="display: flex; justify-content: space-between; padding: 0.5rem">
							<div>
								<p style="font-size: 0.9rem; color: rgb(var(--color-primary)); margin-bottom: 0">
									{{ `${coluna.nome} ${coluna.unidade || ''}` }}
								</p>
								<p
									style="
										font-size: 0.5rem;
										color: rgb(var(--color-primary));
										margin-bottom: 0;
										text-align: start;
									"
								>
									{{ value.find((ca) => ca.coluna === coluna.nome)?.key || 'Não informado' }}
								</p>
							</div>
							<KebabMenu
								icon="fas fa-chevron-circle-down"
								:options="atributos"
								style="
									transform: initial;
									color: rgb(var(--color-primary));
									position: relative !important;
									margin: auto 0;
								"
								@input="bindColuna($event, coluna.nome)"
							/>
						</div>
					</th>
				</thead>
				<tbody
					ref="tbody_medicao"
					style="max-height: 60vh; display: block; overflow: auto"
				>
					<tr
						v-for="(dado, index) in paginatedData"
						:key="dado.id"
						style="display: table; width: 100%; position: relative"
					>
						<TableCell
							v-for="attr in value"
							:id="dado.id"
							:key="attr.coluna + attr.key + index"
							:cellvalue="dado[attr.key]"
							:cellkey="attr.key"
							@changed="emit('cellChanged', $event)"
						>
							<div
								style="display: flex"
								class="items-center justify-between truncate max-w-[135px]"
							>
								{{ dado[attr.key] }}
								<Icon
									v-if="validate(attr.coluna, dado[attr.key])"
									icon="icon-park-solid:caution"
									class="text-[#C60020]"
								/>
							</div>
						</TableCell>
						<td
							v-if="dado.id === showById"
							style="position: absolute; right: 0"
						>
							<div style="padding: 0.3rem 1rem; margin: 2px">
								<i
									v-if="!(agree && showById)"
									class="fas fa-trash"
									@click="agree = true"
								/>
								<i
									v-if="agree && showById"
									style="color: #ccbea0"
									:title="$t('clickConfirm')"
									class="fas fa-exclamation-circle"
									@click="deletaMedicao"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="container__crud__pagination py-2 flex w-full flex-col gap-8">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="quantityPerPage"
				:quantity-per-page-options="[5, 10, 15]"
				:total-records="data.length"
				@setQuantityPerPage="quantityPerPage = $event"
				@setStartEnd="startIndex = $event"
			/>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { computed, onUpdated, ref } from 'vue'
import Checkbox from '../Checkbox/Checkbox.vue'
import InputSearch from '../InputSearch/InputSearch.vue'
import KebabMenu from '../KebabMenu/KebabMenu.vue'
import Pagination from '../Pagination/Pagination.vue'
import TableCell from '../TableCell/TableCell.vue'

const emit = defineEmits(['cellChanged', 'change', 'input'])

const props = defineProps({
	colunas: { type: Array, required: true },
	data: { type: Array, required: true },
	value: { type: Array, required: true },
	filename: { type: String, required: true },
	filterIds: { type: Array },
	linhasInconsistentes: { type: Array },
})

const hasScroll = ref(false)
const showInAttention = ref(false)
const agree = ref(false)
const showById = ref(null)
const tbody_medicao = ref()
const query = ref('')
const quantityPerPage = ref(10)
const startIndex = ref(0)

const pageData = computed(() => {
	return props.filterIds?.length
		? props.data.filter((medicao) => props.filterIds?.includes(medicao?.id))
		: showInAttention.value
			? props.linhasInconsistentes
			: query.value
				? filteredByQuery.value
				: props.data
})

const paginatedData = computed(() => {
	return pageData.value.slice(startIndex.value, startIndex.value + quantityPerPage.value)
})

const atributos = computed(() => {
	return Object.keys(props.data[0]).map((m) => {
		return { label: m, value: m }
	})
})

function bindColuna(e, col) {
	const { intent } = e
	console.log('🚀 ~ bindColuna ~ intent:', intent)

	props.value.forEach((ca) => {
		if (ca.coluna === col) {
			ca.key = intent
		}
	})

	emit('input', props.value)
}

const filteredByQuery = computed(() => {
	return props.data.filter((data) =>
		Object.values(data).join('').toLocaleLowerCase().includes(query.value.toLocaleLowerCase()),
	)
})

function validate(col, data) {
	const coluna = props.colunas.find((coluna) => {
		return coluna.nome === col
	})

	const hasError = coluna.validator ? !coluna.validator(data) : null

	return hasError
}

onUpdated(() => {
	window.addEventListener('resize', () => {
		hasScroll.value = tbody_medicao.value.scrollHeight > tbody_medicao.value.clientHeight
	})
})
</script>

<style>
.datamapper__grid__container {
	max-width: 95vw;
	max-height: 50vh;
	overflow: auto;
	border-radius: 5px;
}
</style>
